import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export const usePaginationQuery = () => {
  const [searchParams, setSearchParams] = useSearchParams({
    skip: '0',
    limit: '10',
    search: '',
  })

  const handleChangeParam = useCallback(
    (key: string, value: string) => {
      setSearchParams((prev) => {
        if (value) {
          prev.set(key, value)
        } else {
          prev.delete(key)
        }
        return prev
      })
    },
    [setSearchParams],
  )

  const skip = Number(searchParams.get('skip') ?? 0)
  const limit = Number(searchParams.get('limit') ?? 10)
  const search = searchParams.get('search') ?? ''

  return {
    handleChangeParam,
    skip,
    limit,
    search,
  }
}
